import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from './StAuthGiver';
import axios from 'axios';
        
import Cookies from 'js-cookie';
        
        
const StPvt = () => {
        const { pathname } = useLocation();
                
        const [isValidToken, setIsValidToken] = useState(); // <-- initially undefined
        
        // Authentication globals
        const { user, token } = useAuth();

        // Check for a valid cookie here.
        const [cookieChk, setCookieChk] = useState(Cookies.get("session_id"));
        console.log(cookieChk);
        
        // Update the cookie when it has changed.
        const newCookie = Cookies.get("session_id");
        if (newCookie !== cookieChk ) {
          //setIsValidAuthToken(newCookie);
          console.log("StPvt: Cookie different");
        }       

        // TODO: The checkToken below will have to use the Context global object which will
        // provide the user/token information.
/*              
        function checkToken() {
                
                console.log("StPvt: checkToken");

                if (!token) {
                        console.log("StPvt: invalid auth token");
                        return false;
                }
                else {
                        console.log("StPvt: token = " , token);
                        return true;
                }       
        
        } 
*/

        // To check the authentication when any component either mounts or is updated.
        // This is checked after rendering of the component.
        // Note that this runs only if the pathname changes. ([pathname] after useEffect function
        // definition).
        useEffect(() => {


            const validateSession = async () => {
                    /*
                    try {
                            // Validate the session cookie.
                            await axios.post('/validateCookie');

                            // Refresh the session cookie.
                            await axios.post('/refreshCookie');
                    }
                    catch (err) {
                            console.log("Cookie error");
                            console.log(err);

                    }
                            */
            }

            //const { user, token } = useAuth(); 

            // initial mount or route changed, check token
            console.log("StPvt: useEffect");
            console.log("StPvt: user =" + user);
            console.log("StPvt: token = " + token )

            // Value of the auth cookie.
            console.log("StPvt: cookie =" + cookieChk);
            validateSession();

            console.log()

            if (!token.length || !user.length) {
                    console.log("StPvt: invalid user or auth token");
                    setIsValidToken(false);
                }
                else {
                        console.log("StPvt: token = " , token);
                        setIsValidToken(true);
                }

        }, [pathname]);


        if (isValidToken === undefined) {
                setIsValidToken(!(token===undefined));
                //return null; // or loading indicator/spinner/etc
        }



        console.log("StPvt: isValidToken: " + isValidToken + ", pathname: " + pathname);

        return isValidToken ? <Outlet/> : <Navigate to="/" replace />;
}

export default StPvt;
